import * as Environment from "../base/Environment.js";

import {LoaderSystem, JSONLoaderJob} from "../base/Loader.js";
import {RenderContext, Stage, AnimatableSprite} from "../base/Display2D.js";

import {SiteSection} from "./SiteSection.js";
export {SiteSection};

import {MouseTracker} from "../components/MouseTracker.js";

import {TourSection} from "./TourSection.js";
import {OverlayController} from "./OverlayController.js";
import {ChatController} from "./ChatController.js";
import {PollController} from "./PollController.js";

//
// Site extends Stage
//

export const Site = function (context) {
	Stage.apply (this, arguments);

	if (Site.sharedInstance)
		throw new Error ("Cannot instantiate. Site is singleton.");

	Site.sharedInstance = this;

	var element = this.element;
	element.classList.remove ("sprite");

	if (element.getAttribute ("data-disable-chat") == "yes" ||
		!element.querySelector (".chat-controller"))
		Site.ENABLE_CHAT = false;

	var sections = this.sections = new Array ();
	this.setUpContent ();

	if (Site.ENABLE_CHAT && Site.PRELOAD_CHAT)
		this.setUpChat ();

	context.resizeDispatcher.addListener ("scroll", this.scroll, this);

	this.addListener ("resize", this.resize, this);
	this.resize ();

	window.setTimeout (function () {
		this.resize ();

	}.bind (this), 50);
	
	if (Environment.FAST_PASS) {
		window.setTimeout (function () {
			this.openChat ();
			
		}.bind (this), 2000);
		
		/*
		*/

		/*
		window.setTimeout (function () {
			this.openPoll ();

		}.bind (this), 500);
		*/

		/*
		window.setTimeout (function () {
			Site.openCreditPoints (true);

		}.bind (this), 550);
		*/

		/*
		window.setTimeout (function () {
			this.enableWideSidePanel (true);

		}.bind (this), 550);
		*/
		
		/*
		window.setTimeout (function () {
			 // Site.openOverlay ("opinionaire");
			 // Site.openOverlay ("help");
			  Site.openOverlay ("downloads");
			 // Site.openOverlay ("agenda");
			 // Site.openOverlay ("credit-points");
			 // Site.openOverlay ("privacy");

		 }.bind (this), 50);
		 */
		 
		/*
		
		window.setTimeout (function () {
			Site.requestCreditPoints ();
			
		 }.bind (this), 1000);
		*/
		
	}

};

window.Site = Site;

Site.ENABLE_CHAT = true && !Environment.IS_IE;
Site.PRELOAD_CHAT = true;

Site.openChat = function (channelName) {
	this.sharedInstance.openChat (channelName);

};

Site.openPoll = function (pollName) {
	this.sharedInstance.openPoll (pollName);

};

Site.openOverlay = function (overlayName, sourceName) {
	this.sharedInstance.openOverlay (overlayName, sourceName);

};

Site.prototype = Object.create (Stage.prototype);

Site.prototype.resizeContext = function (context) {
	if (this.skipResize)
		return;

	this.setSize (
		Environment.IS_TOUCH_DEVICE ?
			RenderContext.getViewportSize () :
			this.getRulerSize ()

	);

};

Site.prototype.setUpContent = function () {
	const element = this.element;

	const infoChatButton = this.infoChatButton = element.querySelector ("#information .label-icon.label-icon--chat")?.parentNode?.parentNode;
	
	const mainElement = this.mainElement = document.querySelector ("main");
	const footerElement = this.footerElement = document.querySelector ("footer");
	
	
	const now = new Date ().getTime ();
	const timeToShowCreditPoints = new Date (2023, 8, 21, 0, 0).getTime ();
	const timeRemaining = timeToShowCreditPoints - now;
	
	if (timeRemaining <= 0 || location.host.indexOf (".beta.") > 0 || Environment.FAST_PASS) {
		this.setShowsCreditPoints (true);
		
	} else {
		this.setShowsCreditPoints (false);
		
		window.setTimeout (function () {
			this.setShowsCreditPoints (true);
			
		}.bind (this), timeRemaining);
		
	}
	
	this.setHasCreditPoints (!!window.exparea_config.hasCreditPoints);
	
	
	const mouseTracker = this.mouseTracker = this.attachSprite (MouseTracker);
	mouseTracker.takeElement (element);

	mouseTracker.accelerationFactor = .005; // .0085; // .005;
	mouseTracker.dampFactor = .9;

	const sidePanel = this.sidePanel = element.querySelector (".side-panel");
	if (sidePanel)
		element.appendChild (sidePanel);

	this.setUpSectionControllers (element);

	this.setUpNavigation ();
	
};

Site.prototype.setShowsCreditPoints = function (showsCreditPoints) {
	Site.showsCreditPoints = showsCreditPoints
	
	const element = this.element;
	
	const visibleCreditPointsElements = element.querySelectorAll (".credit-points-visible");
	for (let i = visibleCreditPointsElements.length; i--;) {
		const visibleCreditPointsElement = visibleCreditPointsElements [i];
		visibleCreditPointsElement.style.display = showsCreditPoints ? "" : "none";
		
	}
	
	const invisibleCreditPointsElements = element.querySelectorAll (".credit-points-invisible");
	for (let i = invisibleCreditPointsElements.length; i--;) {
		const invisibleCreditPointsElement = invisibleCreditPointsElements [i];
		invisibleCreditPointsElement.style.display = showsCreditPoints ? "none" : "";
		
	}
	
};

Site.prototype.setHasCreditPoints = function (hasCreditPoints) {
	Site.hasCreditPoints = hasCreditPoints
	
	const element = this.element;
	
	const visibleCreditPointsElements = element.querySelectorAll (".credit-points-obtained");
	for (let i = visibleCreditPointsElements.length; i--;) {
		const visibleCreditPointsElement = visibleCreditPointsElements [i];
		visibleCreditPointsElement.style.display = hasCreditPoints ? "" : "none";
		
	}
	
	const invisibleCreditPointsElements = element.querySelectorAll (".credit-points-not-obtained");
	for (let i = invisibleCreditPointsElements.length; i--;) {
		const invisibleCreditPointsElement = invisibleCreditPointsElements [i];
		invisibleCreditPointsElement.style.display = hasCreditPoints ? "none" : "";
		
	}
	
};

Site.prototype.setUpSectionControllers = function (element) {
	var sectionElements = element.querySelectorAll ("[data-class-name]");
	if (!sectionElements.length)
		sectionElements = [element];

	var sections = this.sections;

	for (var i = 0; i < sectionElements.length; i++) {
		var sectionElement = sectionElements [i];
		if (sectionElement.getAttribute ("data-processed") == "yes")
			continue;

		var section = sectionElement.section;

		if (!section) {
			sectionElement.setAttribute ("data-processed", "yes");

			var sectionClassName = sectionElement.getAttribute ("data-class-name");

			section = sectionElement.section = this.attachSprite (window [sectionClassName] || SiteSection);
			section.takeElement (sectionElement);

			sections.push (section);

		}

	}

};

Site.prototype.setUpNavigation = function () {
	const element = this.element;
	const headerNavigation = this.headerNavigation = element.querySelector (".header-navigation");

	const chatButton = this.chatButton = headerNavigation.querySelector (".tools-button--chat");
	if (chatButton && !Site.ENABLE_CHAT)
		chatButton.parentNode.removeChild (chatButton);

	const auditoriumButton = this.auditoriumButton = headerNavigation.querySelector (".tools-button--auditorium");
	
	const pollButton = this.pollButton = headerNavigation.querySelector (".tools-button--poll");

	const calendarButton = this.calendarButton = headerNavigation.querySelector (".tools-button--calendar");

	const downloadButton = this.downloadButton = headerNavigation.querySelector (".tools-button--files");

	const helpButton = this.helpButton = headerNavigation.querySelector (".tools-button--help");
	const privacyButton = this.privacyButton = headerNavigation.querySelector (".tools-button--privacy");
	
	const creditPointsButton = this.creditPointsButton = headerNavigation.querySelector (".tools-button--credit-points");
	
};

Site.prototype.setShowsNotification = function (showsNotification) {
	this.showsNotification = showsNotification;
	
	const notificationBadge = this.chatButton.firstElementChild;
	notificationBadge.style.display = showsNotification ? "" : "none";

};

Site.prototype.changeRoom = function () {
	const auditoriumButton = this.auditoriumButton;
	if (auditoriumButton) {
		const controller = TourSectionController.sharedInstance;
		
		const currentSection = controller.currentSection;
		if (currentSection.name == "auditorium")
			auditoriumButton.classList.add ("active");
		else
			auditoriumButton.classList.remove ("active");
		
	}
	
};

Site.prototype.resize = function (sender) {
	this.isResizing = true;

	const viewportSize = this.size;

	const mouseTracker = this.mouseTracker;
	mouseTracker.setViewSize (viewportSize);

	this.sidePanelWidth = 365 + 12;

	this.updateSceenLayout ();

	if (sender)
		this.renderInContext ();

	this.scroll ();

	this.isResizing = false;

};

Site.prototype.updateSceenLayout = function () {
	const viewportSize = this.size.concat ();
	const sections = this.sections;

    const headerHeight = this.headerNavigation.offsetHeight;
	viewportSize [1] -= headerHeight;

	let shiftOut;

	const sidePanel = this.sidePanel;
	if (sidePanel) {
		const sidePanelWidth = /* viewportSize [0] * .75 || */ this.sidePanelWidth || 0;
		
		const sidePanelPercentage = this.sidePanelPercentage || 0;
		const wideSidePanelExpansion = this.wideSidePanelExpansion || 0;

		const missingWidth = viewportSize [0] - sidePanelWidth + 4;

		const chatOffset = Math.round (
			sidePanelWidth * sidePanelPercentage +
			missingWidth * wideSidePanelExpansion * sidePanelPercentage

		);
		viewportSize [0] -= chatOffset;

		sidePanel.style.top = headerHeight + "px";
		sidePanel.style.left = viewportSize [0] + "px";
		sidePanel.style.width = Math.max (sidePanelWidth, chatOffset) + "px";

	}

	const overlayController = this.overlayController;

	if (overlayController && overlayController.isAwake) {
		overlayController.setPosition (-shiftOut, headerHeight);
		overlayController.setViewSize (viewportSize);

	}

	for (let i = sections.length; i--;) {
		const section = sections [i];

		section.setPosition (-shiftOut, headerHeight);
		section.setViewSize (viewportSize);

	}


};

Site.prototype.scroll = function (sender) {
	var size = this.size;
	var sections = this.sections;

	for (var i = sections.length; i--;) {
		var section = sections [i];
		var sectionElement = section.element;

		var pageBounds = section.pageBounds = sectionElement.getBoundingClientRect ();

		if (// pageBounds.height &&
			pageBounds.top < size [1] * 1.25 &&
			pageBounds.bottom > -size [1] * .5) {
			if (!section.didStartLoading) {
				section.startLoading ();

			}

		}

		if (// pageBounds.height &&
			pageBounds.top < size [1] + (section.viewOffsetTop || 0) &&
			pageBounds.bottom > 0) {
			if (!section.isAwake)
				section.awake ();

			section.scroll (!sender);

		} else {
			if (section.isAwake)
				section.sleep ();

			continue;

		}

	}

};

Site.prototype.openChat = function (channelDescription) {
	if (!Site.ENABLE_CHAT)
		return;

	const chatController = this.chatController;
	const chatElement = chatController.element;
	const expareaWindow = chatElement.querySelector ("iframe").contentWindow;

	if (!(expareaWindow.ChatController && expareaWindow.ChatController.sharedInstance))
		return;

	expareaWindow.ChatController.setShowsChatNavigation (!channelDescription);

	if (!channelDescription)
		channelDescription =
			this.currentChatDescription ||
			window.exparea_config.defaultChatable ||
			Site.DEFAULT_CHAT_DESCRIPTION;
	
	const channelName = channelDescription.id + "|" + channelDescription.type;

	const state = this.states ["ShowSidePanel"] || {phase: 0};
	const delayed = state.phase < .1;

	const section = TourSectionController.sharedInstance.currentSection;
	
	if (channelName != "undefined|undefined") {
		if (chatController && chatController.channelName != channelName) {
			chatController.setChannelName (channelName, delayed);
			expareaWindow.ChatController.selectChat (channelDescription);

			if (this.showsChat) {
				if (section.name == "lounge")
					this.enableWideSidePanel (true);

				return;

			}

		}

	}
	
	const infoChatButton = this.infoChatButton;

	if (infoChatButton && this.showsNotification) {
		if (window.exparea_config.userId !=
			window.exparea_config.moderator.id) {
			this.setShowsNotification (false);
			eval (infoChatButton.getAttribute ("href").split ("javascript:").pop ());
			return;
			
		}
		
	}
	
	const showsChat = this.showsChat = !this.showsChat;
	
	if (channelName != "close") {
		if (section.name == "lounge") {
			if (showsChat) {
				this.enableWideSidePanel (true);

			} else {
				if (!this.isWideSidePanelEnabled) {
					this.showsChat = true;
					this.enableWideSidePanel (true);
					return;

				}

			}

		} else {
			this.enableWideSidePanel (false);

		}

	}

	const chatButton = this.chatButton;

	if (showsChat) {
		this.setUpChat ();

		if (chatElement.style.visibility)
			chatElement.style.visibility = "";

		const chatController = this.chatController;
		chatController.setChannelName (channelName, delayed);

		chatButton.classList.add ("active");

		// if (channelName)
		//	expareaWindow.ChatController.selectChat (channelDescription);

		this.showSidePanel ();

		this.presentSidePanelContent (chatElement);

		this.isChatBehind = true;
		this.showsPoll = false;
		
		if (this.pollButton)
			this.pollButton.classList.remove ("active");

	} else {
		this.closeSidePanelController (this.chatController);

	}

};

Site.prototype.setUpChat = function () {
	let chatController = this.chatController;
	if (chatController)
		return;

	const element = this.element;
	const chatElement = element.querySelector (".chat-controller");

	if (!chatElement)
		return;

	chatController = this.chatController = this.attachSprite (ChatController);
	chatController.takeElement (chatElement);

	chatElement.style.visibility = "hidden";

};

Site.DEFAULT_CHAT_DESCRIPTION = {
	id: 1,
	label: "Allgemeiner Chat",
	type: "App\\Models\\Channel"
	
};

Site.prototype.announceChat = function (channelDescription) {
	const currentChatDescription =
		channelDescription ||
		window.exparea_config.defaultChatable ||
		Site.DEFAULT_CHAT_DESCRIPTION;
	
	if (this.showsChat) {
		if (!this.currentChatDescription ||
			this.currentChatDescription.id != currentChatDescription.id) {

			const expareaWindow = this.chatController.element.querySelector ("iframe").contentWindow;
			if (!(expareaWindow.ChatController && expareaWindow.ChatController.sharedInstance))
				return;

			expareaWindow.ChatController.selectChat (currentChatDescription);

		}

	}

	this.currentChatDescription = currentChatDescription;

};

Site.prototype.openPoll = function (pollDescription) {
	// this.pollName = pollName;
	const showsPoll = this.showsPoll = pollDescription != "close" && !this.showsPoll;

	const pollButton = this.pollButton;

	if (showsPoll)
		pollButton.classList.add ("active");
	else
		pollButton.classList.remove ("active");

	if (showsPoll) {
		this.setUpPoll ();

		const pollController = this.pollController;
		const pollElement = pollController.element;

		this.presentSidePanelContent (pollElement);

		if (pollElement.style.visibility)
			pollElement.style.visibility = "";

		pollController.setPollId (/* pollId */);

		this.showSidePanel ();

		this.isPollBehind = true;
		this.showsChat = false;
		this.chatButton.classList.remove ("active");

	} else {
		this.closeSidePanelController (this.pollController);

	}

	this.enableWideSidePanel (false);

};

Site.prototype.setUpPoll = function () {
	let pollController = this.pollController;
	if (pollController)
		return;

	const element = this.element;
	const pollElement = element.querySelector (".poll-controller");

	if (!pollElement)
		return;

	pollController = this.pollController = this.attachSprite (PollController);
	pollController.takeElement (pollElement);

	pollElement.style.visibility = "hidden";
	// this.sidePanel.appendChild (pollElement);

};

Site.prototype.showSidePanel = function () {
	if (this.showsSidePanel)
		return;

	this.showsSidePanel = true;

	this.startAnimation ("ShowSidePanel", {direction: 1, rate: this.getSidePanelAnimationRate ()});

};

Site.prototype.hideSidePanel = function () {
	if (!this.showsSidePanel)
		return;

	this.showsSidePanel = false;

	this.startAnimation ("ShowSidePanel", {direction: 0, rate: this.getSidePanelAnimationRate ()});

};

Site.prototype.closeSidePanelController = function (controller) {
	if (controller == this.pollController && this.isChatBehind) {
		this.showsPoll = false;
		this.isPollBehind = false;
		if (this.pollButton)
			this.pollButton.classList.remove ("active");

		this.showsChat = true;
		this.chatButton.classList.add ("active");

		this.presentSidePanelContent (this.chatController.element, true);

	} else if (controller == this.chatController && this.isPollBehind) {
		this.showsChat = false;
		this.isChatBehind = false;
		this.chatButton.classList.remove ("active");

		this.showsPoll = true;
		if (this.pollButton)
			this.pollButton.classList.add ("active");

		this.presentSidePanelContent (this.pollController.element, true);

	} else {
		this.showsChat = false;
		this.isChatBehind = false;
		this.chatButton.classList.remove ("active");

		this.showsPoll = false;
		this.isPollBehind = false;
		if (this.pollButton)
			this.pollButton.classList.remove ("active");

		this.hideSidePanel ();

	}

};

Site.prototype.getSidePanelAnimationRate = function () {
	const rate = SiteSection.TRANSITION_SPEED * (this.isWideSidePanelEnabled ? .75 : 1);

	return rate;

};

Site.prototype.animateShowSidePanel = function () {
	const state = this.updatedState ("ShowSidePanel");
	let t = state.phase;
	t = .5 - Math.cos (Math.PI * t) * .5;
	t = .5 - Math.cos (Math.PI * t) * .5;

	this.sidePanelPercentage = t;

	this.updateSceenLayout ();

	this.renderInContext ();
	
	if (state.phase == 0) {
		const expareaWindow = this.chatController.element.querySelector ("iframe").contentWindow;
		if (!(expareaWindow.ChatController && expareaWindow.ChatController.sharedInstance))
			return;
		
		this.chatController.channelName = "";
		expareaWindow.ChatController.sharedInstance.selectChat (this.currentChatDescription);
		
	}
	
};

Site.prototype.enableWideSidePanel = function (isWideSidePanelEnabled) {
	if (this.isWideSidePanelEnabled == isWideSidePanelEnabled)
		return;

	this.isWideSidePanelEnabled = isWideSidePanelEnabled;

	const sidePanelPercentage = this.sidePanelPercentage;

	if (sidePanelPercentage) {
		const rate = SiteSection.TRANSITION_SPEED * .75;

		if (isWideSidePanelEnabled)
			this.startAnimation ("WideSidePanel", {direction: 1, rate: rate});
		else
			this.startAnimation ("WideSidePanel", {direction: 0, rate: rate});

	} else {
		this.stopAnimation ("WideSidePanel");

		const wideSidePanelExpansion = this.wideSidePanelExpansion = isWideSidePanelEnabled ? 1 : 0;
		this.states ["WideSidePanel"] = {phase: wideSidePanelExpansion};

	}

	this.renderInContext ();

};

Site.prototype.animateWideSidePanel = function () {
	const state = this.updatedState ("WideSidePanel");

	let t = state.phase;
	t = .5 - Math.cos (Math.PI * t) * .5;
	t = .5 - Math.cos (Math.PI * t) * .5;

	this.wideSidePanelExpansion = t;
	this.updateSceenLayout ();

};

Site.prototype.presentSidePanelContent = function (sidePanelContent, reversed) {
	const sidePanel = this.sidePanel;
	// sidePanel.appendChild (sidePanelContent);

	if (this.showsSidePanel) {
		this.sidePanelContent = sidePanelContent;
		this.startAnimation ("PresentSidePanelContent", {direction: 1, rate: .03, phase: 0, reversed: reversed});

	} else {
		const children = sidePanel.children;
		for (let i = children.length; i--;) {
			const child = children [i];
			child.style.visibility = child == sidePanelContent ? "" : "hidden";
			child.style.zIndex = child == sidePanelContent ? 1 : 0;
			child.style.left = 0;

		}

	}

};

Site.prototype.animatePresentSidePanelContent = function () {
	const state = this.updatedState ("PresentSidePanelContent");
	let t = 1 - state.phase;
	t = t * t * t;
	t = .5 - Math.cos (Math.PI * t) * .5;

	const sidePanel = this.sidePanel;
	const sidePanelContent = this.sidePanelContent;
	const children = sidePanel.children;

	const panelWidth = parseFloat (sidePanel.style.width);

	for (let i = children.length; i--;) {
		const child = children [i];

		if (t < 1) {
			child.style.visibility = "";

			if (state.reversed) {
				if (child == sidePanelContent) {
					child.style.zIndex = 1;
					child.style.left = "0";

				} else {
					child.style.zIndex = 2;
					child.style.left = (1 - t) * panelWidth + "px";

				}

			} else {
				if (child == sidePanelContent) {
					child.style.zIndex = 1;
					child.style.left = t * panelWidth + "px";

				} else {
					child.style.zIndex = 0;
					child.style.left = "0";

				}

			}

		} else {
			child.style.visibility = child == sidePanelContent ? "" : "hidden";

		}

	}

};

Site.prototype.openOverlay = function (overlayName, sourceName) {
	this.overlaySourceName = sourceName;
	
	if (overlayName == this.overlayName) {
		this.closeOverlay ();
		return;

	}

	this.revertOverlayNavigationState ();

	this.overlayName = overlayName;

	const selector = ".site-assets ." + overlayName + "-overlay";

	let overlayController = this.overlayController;
	if (!overlayController)
		overlayController = this.overlayController = this.attachSprite (OverlayController);

	const element = this.element;
	const overlayContent = element.querySelector (selector);

	overlayController.takeContentElement (overlayContent);

	overlayController.awake ();
	overlayController.open ();

	this.updateSceenLayout ();

	this.renderInContext ();


	switch (overlayName) {
		case "agenda":
			this.calendarButton && this.calendarButton.classList.add ("active");
			break;
		case "downloads":
			this.downloadButton && this.downloadButton.classList.add ("active");
			break;
		case "help":
			this.helpButton && this.helpButton.classList.add ("active");
			break;
		case "privacy":
			this.privacyButton && this.privacyButton.classList.add ("active");
			break;
		case "credit-points":
			this.creditPointsButton && this.creditPointsButton.classList.add ("active");
			break;

	}


};

Site.prototype.revertOverlayNavigationState = function () {
	const overlayName = this.overlayName;

	switch (overlayName) {
		case "agenda":
			this.calendarButton && this.calendarButton.classList.remove ("active");
			break;
		case "downloads":
			this.downloadButton && this.downloadButton.classList.remove ("active");
			break;
		case "help":
			this.helpButton && this.helpButton.classList.remove ("active");
			break;
		case "privacy":
			this.privacyButton && this.privacyButton.classList.remove ("active");
			break;
		case "credit-points":
			this.creditPointsButton && this.creditPointsButton.classList.remove ("active");
			break;
		
	}

};

Site.prototype.closeOverlay = function () {
	const overlayController = this.overlayController;
	overlayController.close ();

	this.revertOverlayNavigationState ();

	this.overlayName = undefined;

};

Site.requestCreditPoints = function () {
	this.sharedInstance.requestCreditPoints ();

};

Site.prototype.requestCreditPoints = function () {
	this.closeOverlay ();
	
	const loader = LoaderSystem.getSharedInstance ();
	const job = loader.jobForPathOfClass (
		"/api/credits",
		JSONLoaderJob,
		true
		
	);
	job.method = "POST";
	job.parameters = {
		source: this.overlaySourceName
		
	};
	job.addListener ("complete", this.completeSendCreditPointRequest, this);
	loader.enqueueJob (job);
	
	// trace ("job.parameters", JSON.stringify (job.parameters));
	
	window.setTimeout (function () {
		this.setHasCreditPoints (true);
		Site.openOverlay ("credit-points");
		
	}.bind (this), 850);
	
};

Site.prototype.completeSendCreditPointRequest = function (job) {
	const didSucceed =
		job.data.success == true ||
		job.data.error != true;
	
};
